export enum SystemCapability {
  CREATE_EVENT = 'CREATE_EVENT',
  CREATE_TABLE = 'CREATE_TABLE',
  CREATE_ORGANIZATION = 'CREATE_ORGANIZATION',
  MODERATE_CONTENT = 'MODERATE_CONTENT',
  MANAGE_USERS = 'MANAGE_USERS',
  MANAGE_SYSTEM = 'MANAGE_SYSTEM',
}

export enum OrgCapability {
  ORG_VIEW = 'ORG_VIEW',
  ORG_TABLE_CREATE = 'ORG_TABLE_CREATE',
  ORG_EVENT_CREATE = 'ORG_EVENT_CREATE',
  ORG_EVENT_MANAGE = 'ORG_EVENT_MANAGE',
  ORG_MEMBER_INVITE = 'ORG_MEMBER_INVITE',
  ORG_MEMBER_VIEW = 'ORG_MEMBER_VIEW',
  ORG_MEMBER_MANAGE = 'ORG_MEMBER_MANAGE',
  ORG_ROLE_ASSIGN = 'ORG_ROLE_ASSIGN',
  ORG_EDIT = 'ORG_EDIT',
  ORG_DELETE = 'ORG_DELETE',
}

export const SystemPower = {
  USER: 10,
  ASSOCIATION: 40,
  MODERATOR: 70,
  ADMINISTRATOR: 100,
} as const;

export const OrgRolePower = {
  MEMBER: 10,
  MODERATOR: 40,
  ADMIN: 70,
  OWNER: 100,
} as const;

export const SystemRoleCapabilities: Record<string, SystemCapability[]> = {
  USER: [
    SystemCapability.CREATE_ORGANIZATION],
  ASSOCIATION: [
    SystemCapability.CREATE_TABLE,
    SystemCapability.CREATE_EVENT,
    SystemCapability.CREATE_ORGANIZATION,
  ],
  MODERATOR: [
    SystemCapability.CREATE_TABLE,
    SystemCapability.CREATE_EVENT,
    SystemCapability.CREATE_ORGANIZATION,
    SystemCapability.MODERATE_CONTENT,
  ],
  ADMINISTRATOR: Object.values(SystemCapability),
};

export const OrgRoleCapabilities: Record<string, OrgCapability[]> = {
  MEMBER: [
    OrgCapability.ORG_VIEW,
    OrgCapability.ORG_MEMBER_VIEW],
  MODERATOR: [
    OrgCapability.ORG_VIEW,
    OrgCapability.ORG_MEMBER_VIEW,
    OrgCapability.ORG_TABLE_CREATE,
    OrgCapability.ORG_EVENT_CREATE,
    OrgCapability.ORG_EVENT_MANAGE,
    OrgCapability.ORG_MEMBER_INVITE,
  ],
  ADMIN: [
    OrgCapability.ORG_VIEW,
    OrgCapability.ORG_MEMBER_VIEW,
    OrgCapability.ORG_TABLE_CREATE,
    OrgCapability.ORG_EVENT_CREATE,
    OrgCapability.ORG_EVENT_MANAGE,
    OrgCapability.ORG_MEMBER_INVITE,
    OrgCapability.ORG_MEMBER_MANAGE,
    OrgCapability.ORG_ROLE_ASSIGN,
    OrgCapability.ORG_EDIT,
  ],
  OWNER: Object.values(OrgCapability),
};
